import React from "react";
import ReactJWPlayer from "react-jw-player";

// NOTE:
// react-jw-player does not yet support typescript,
// so we leave this as a jsx file.

export default ({
  url,
  title,
  image,
  autoPlay,
  script,
  id,
  className = "",
  onFinish,
}) => {
  return (
    <React.Fragment>
      {/* <h4>{title}</h4> */}
      <div className="player">
      <ReactJWPlayer
        className={className}
        playerId={id}
        playerScript={script}
        file={url}
        image={image}
        isAutoPlay={autoPlay}
        customProps={{ skin: { name: "seven" }, width: "100%" }}
        onAdComplete={(e) => console.log("e", e)}
        onTime={(e) => {
          if (e.position === e.duration) {
            onFinish();
          }
        }}
      />
      </div>
    </React.Fragment>
  );
};
